<script>
import ItineraryIncludeWrapper from '../../components/itinerary/ItineraryIncludeWrapper';

export default {
  name: 'ItineraryEditInclude',
  components: {
    ItineraryIncludeWrapper,
  },
};
</script>

<template>
  <div>
    <itinerary-include-wrapper
      title="Included"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryEditInclude.vue